import type { CSSObject } from '@emotion/react'
import color from 'color'
import {
  Color,
  FontWeight,
  OppositeTheme,
  Size,
  Spacing,
  Typography,
} from '@opallabs/gem'
import { colors } from '@opallabs/lapidary'
import type { StyleProps } from './types'

const unseenOverrides = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: colors[theme].secondary.yellow100,
  color: Color[theme].Text.Default,
  '&:hover': {
    backgroundColor: color(colors[theme].secondary.yellow100)
      .darken(0.06)
      .hex(),
  },
  '&:active': {
    backgroundColor: color(colors[theme].secondary.yellow100)
      .darken(0.12)
      .hex(),
  },
})

export const mainTab = ({
  hasUnseen,
  theme,
}: StyleProps & { hasUnseen: boolean }): CSSObject => ({
  backgroundColor: Color[theme].Surface.N000,
  color: Color[theme].Text.Default,
  ...Typography.T500,
  alignItems: 'center',
  borderRadius: Size.Rounding / 2,
  display: 'flex',
  flexWrap: 'nowrap',
  fontWeight: FontWeight.Bold,
  fontSize: 11,
  padding: Spacing.S,
  position: 'relative',
  textTransform: 'uppercase',

  '& > div': {
    alignItems: 'center',
    display: 'flex',
  },
  '&::before': {
    borderRadius: Size.Rounding / 2,
  },

  '&:hover::before': {
    backgroundColor: Color[OppositeTheme[theme]].Translucent.N06,
  },
  '&:active::before': {
    backgroundColor: Color[OppositeTheme[theme]].Translucent.N12,
  },
  ...(hasUnseen && unseenOverrides({ theme })),
})

export const mainTabSelected = ({ theme }: StyleProps): CSSObject => ({
  backgroundColor: Color[theme].Surface.A200,
  color: Color[theme].Text.InvertedDefault,
})
